import { render } from "./EditDocumentRecord.vue?vue&type=template&id=2c30d264&scoped=true"
import script from "./EditDocumentRecord.vue?vue&type=script&lang=js"
export * from "./EditDocumentRecord.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./EditDocumentRecord.vue?vue&type=style&index=1&id=2c30d264&scoped=true&lang=css"
import "./EditDocumentRecord.vue?vue&type=style&index=2&id=2c30d264&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c30d264"]])

export default __exports__